import React, { useEffect, useState } from 'react';
import './FeatureStyles.css';
import './GitHubCopilotFeature.css';

const GitHubCopilotAnimation = () => {
  const [activeStage, setActiveStage] = useState(0);

  const stages = [
    { id: 0, label: 'AI Creates\nTest', color: '#3b82f6' },
    { id: 1, label: 'AI Analyses\nFailure', color: '#3b82f6' },
    { id: 2, label: 'AI Suggests\nBugfix', color: '#3b82f6' },
    { id: 3, label: 'AI Implements\nBugfix', color: '#3b82f6' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStage(prev => (prev + 1) % 4);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="feature-animation github-copilot">
      <div className="copilot-cycle-simple">
        {/* Circle track */}
        <div className="cycle-track" />

        {/* Rotating highlight */}
        <div
          className="cycle-highlight"
          style={{ transform: `rotate(${activeStage * 90}deg)` }}
        />

        {/* Center logo */}
        <div className="cycle-hub">
          <img src="/qatelogo.png" alt="Qate" className="cycle-logo" loading="lazy" />
        </div>

        {/* Stage nodes */}
        {stages.map((stage, index) => {
          const isActive = activeStage === index;
          return (
            <div
              key={stage.id}
              className={`cycle-stage stage-${index} ${isActive ? 'active' : ''}`}
            >
              <div
                className="stage-dot"
                style={{ background: isActive ? stage.color : '#e5e7eb' }}
              />
              <span
                className="stage-label"
                style={{ color: isActive ? stage.color : '#9ca3af' }}
              >
                {stage.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const GitHubCopilotFeature = {
  icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
      <circle cx="12" cy="12" r="4"/>
    </svg>
  ),
  title: <>AI Coding Agent Integration <span className="cycle-highlight-text">It closes the cycle loop!</span></>,
  description: "Close the loop from bug detection to fix. When AI creates a bugfix suggestion, automatically create an issue with full context - code snippets, root cause analysis, and suggested fixes. Optionally assign to an AI coding agent to get an automated PR or MR with the solution. Works with GitHub Copilot and GitLab Duo.",
  highlight: [
    "Paid Plan",
    <><svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{ verticalAlign: '-2px', marginRight: '4px' }}><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/></svg>GitHub</>,
    <><svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{ verticalAlign: '-2px', marginRight: '4px' }}><path d="M22.65 14.39L12 22.13.35 14.39c-.18-.14-.25-.37-.18-.58L2.27 8.6l2.1 6.45h15.25l2.1-6.45 2.11 5.21c.07.21 0 .44-.18.58z"/><path d="M12 22.13L17.62 15.05H6.38L12 22.13z"/><path d="M6.38 15.05L2.27 8.6 12 22.13 6.38 15.05z"/><path d="M2.27 8.6l-.92 2.83c-.08.26.01.54.23.71L12 22.13 2.27 8.6z"/><path d="M2.27 8.6h4.11L4.38 2.55c-.1-.3-.52-.3-.62 0L2.27 8.6z"/><path d="M17.62 15.05L21.73 8.6 12 22.13l5.62-7.08z"/><path d="M21.73 8.6l.92 2.83c.08.26-.01.54-.23.71L12 22.13 21.73 8.6z"/><path d="M21.73 8.6h-4.11l1.99-6.05c.1-.3.52-.3.62 0L21.73 8.6z"/></svg>GitLab</>
  ],
  animation: <GitHubCopilotAnimation />
};

export default GitHubCopilotFeature;
